import Vue from 'vue';
import Vuex, { Module } from 'vuex';
import axios from 'axios';

import { handleError } from '@/utils/helperFunctions';
import { endpoints } from '@/endpoints/endpoints';
import { Email, EmailState } from '@/definitions/definitions';

// Vue.use(Vuex);

export const emails: Module<EmailState, any> = {
  namespaced: true,
  state: {
    emailLogs: [],
    isSearching: false,
    totalCount: 0,
    currentPage: 1,
    itemsPerPage: 10,
    isModalOpen: false,
    modalContent: {} as Email,
  },
  mutations: {
    setEmailLogs(state, logs) {
      state.emailLogs = logs;
    },
    setIsSearching(state, status) {
      state.isSearching = status;
    },
    setTotalCount(state, count) {
      state.totalCount = count;
    },
    setCurrentPage(state, page) {
      state.currentPage = page;
    },
    setItemsPerPage(state, size) {
      state.itemsPerPage = size;
    },
    setIsModalOpen(state, status) {
      state.isModalOpen = status;
    },
    setModalContent(state, content) {
      state.modalContent = content;
    },
  },
  getters: {
    getModalContent: (state) => {
      return state.modalContent;
    },
  },
  actions: {
    async fetchEmailLogs(
      { commit, state, rootState },
      { searchInput = '', startDate = null, endDate = null } = {},
    ) {
      commit('setIsSearching', true);
      try {
        const response = await axios.get(endpoints.getEmailLogs, {
          headers: { Authorization: `bearer ${rootState.account.token}` },
          params: {
            PageNumber: state.currentPage,
            PageSize: state.itemsPerPage,
            search: searchInput,
            startDate,
            endDate,
          },
        });
        commit('setEmailLogs', response.data.Data.EmailList || []);
        commit('setTotalCount', response.data.Data.TotalCount);
      } catch (err) {
        const msg = handleError(
          err,
          'Sorry! looks like something went wrong while loading your Email Logs',
        );
        this.dispatch('addError', msg);
      } finally {
        commit('setIsSearching', false);
      }
    },
    nextPage({ commit, state }) {
      if (state.currentPage * state.itemsPerPage < state.totalCount) {
        commit('setCurrentPage', state.currentPage + 1);
      }
    },
    prevPage({ commit, state }) {
      if (state.currentPage > 1) {
        commit('setCurrentPage', state.currentPage - 1);
      }
    },
    setIsModalOpen({ commit }, data: boolean) {
      commit('setIsModalOpen', data);
    },
  },
};
